module.exports = __webpack_public_path__ + "2f26f753ac3d956cbc2d00dca843cb74.fbx";